import { useState } from 'react';

export function CopyButton({ value, label = 'Copy value' }: { value?: string | null; label?: string }) {
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  async function copy() {
    try {
      if (!navigator.clipboard) return;
    await navigator.clipboard.writeText(value ?? '');
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1400);
    } catch {
      setCopied(false);
    }
  }

  return (
    <button
      type="button"
      className="copy-button"
      aria-label={label}
      title={copied ? 'Copied' : label}
      onClick={() => void copy()}
    >
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
}
